import { Routes } from '@angular/router';

export const customerRoutes: Routes = [
  // Customer Profile
  {
    path: 'customer-profile',
    data: { moduleCode: 'customer_customer_profile' },
    children: [
      { path: '', loadComponent: () => import('./customer-profile/customer-profile').then((m) => m.CustomerProfile) },
      {
        path: 'add',
        loadComponent: () =>
          import('./customer-profile/customer-profile-details/customer-profile-details').then((m) => m.CustomerProfileDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./customer-profile/customer-profile-details/customer-profile-details').then((m) => m.CustomerProfileDetails)
      },
      {
        path: 'customer-profile-import',
        loadComponent: () =>
          import('./customer-profile/customer-profile-import/customer-profile-import').then((m) => m.CustomerProfileImport)
      }
    ]
  },
  // Blacklisted Customer
  {
    path: 'blacklisted-customer',
    data: { moduleCode: 'customer_blacklisted_cust' },
    children: [
      { path: '', loadComponent: () => import('./blacklisted-customer/blacklisted-customer').then((m) => m.BlacklistedCustomer) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./blacklisted-customer/blacklisted-customer-details/blacklisted-customer-details').then(
            (m) => m.BlacklistedCustomerDetails
          )
      }
    ]
  },
  // Customer Class
  {
    path: 'customer-class',
    data: { moduleCode: 'customer_class' },
    children: [
      { path: '', loadComponent: () => import('./customer-class/customer-class').then((m) => m.CustomerClass) },
      {
        path: 'add',
        loadComponent: () => import('./customer-class/customer-class-details/customer-class-details').then((m) => m.CustomerClassDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./customer-class/customer-class-details/customer-class-details').then((m) => m.CustomerClassDetails)
      },
      {
        path: 'customer-class-import',
        loadComponent: () => import('./customer-class/customer-class-import/customer-class-import').then((m) => m.CustomerClassImport)
      }
    ]
  },
  // Customer Group
  {
    path: 'customer-group',
    data: { moduleCode: 'customer_grp' },
    children: [
      { path: '', loadComponent: () => import('./customer-group/customer-group').then((m) => m.CustomerGroup) },
      {
        path: 'add',
        loadComponent: () => import('./customer-group/customer-group-details/customer-group-details').then((m) => m.CustomerGroupDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./customer-group/customer-group-details/customer-group-details').then((m) => m.CustomerGroupDetails)
      },
      {
        path: 'customer-group-import',
        loadComponent: () => import('./customer-group/customer-group-import/customer-group-import').then((m) => m.CustomerGroupImport)
      }
    ]
  },
  // New Customer Request
  {
    path: 'customer-request',
    data: { moduleCode: 'customer_new_customer' },
    children: [
      { path: '', loadComponent: () => import('./customer-request/customer-request').then((m) => m.CustomerRequest) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./customer-request/customer-request-details/customer-request-details').then((m) => m.CustomerRequestDetails)
      }
    ]
  },
  // Customer Details Update Request
  {
    path: 'customer-details-update',
    data: { moduleCode: 'customer_details_upd' },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./customer-details-update-request/customer-details-update-request').then((m) => m.CustomerDetailsUpdateRequest)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./customer-details-update-request/customer-update-details/customer-update-details').then((m) => m.CustomerUpdateDetails)
      }
    ]
  },
  // Blacklist Customer Request
  {
    path: 'blacklist-customer',
    data: { moduleCode: 'customer_blacklist_reinstate' },
    children: [
      {
        path: '',
        loadComponent: () => import('./blacklist-customer-request/blacklist-customer-request').then((m) => m.BlacklistCustomerRequest)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./blacklist-customer-request/blacklist-customer-request-details/blacklist-customer-request-details').then(
            (m) => m.BlacklistCustomerRequestDetails
          )
      }
    ]
  },
  // Unblacklist Customer Request
  {
    path: 'unblacklist-customer',
    data: { moduleCode: 'customer_unblacklist_cust' },
    children: [
      {
        path: '',
        loadComponent: () => import('./unblacklist-customer-request/unblacklist-customer-request').then((m) => m.UnblacklistCustomerRequest)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./unblacklist-customer-request/unblacklist-customer-request-details/unblacklist-customer-request-details').then(
            (m) => m.UnblacklistCustomerRequestDetails
          )
      }
    ]
  }
];
